module.exports = __webpack_public_path__ + "static/media/icon-closed.1b954019.svg";